/***************************
 ***** GEO API GOUV *****
 **************************/

const fetchCityList = async (cp: string) => {
	return fetch(
		`https://geo.api.gouv.fr/communes?codePostal=${cp}&fields=nom,codeInsee,codesPostaux,codeDepartement,codeRegion&format=json&geometry=centre`
	)
		.then((response) => response.json())
		.catch((e) => null)
}

/***************************
 ***** API ADRESSE GOUV *****
 **************************/

const getCoordinates = async (adresse: string, postCode: string, city: string) => {
	return fetch(
		`https://api-adresse.data.gouv.fr/search/?q=${adresse}&limit=1&postcode=${postCode}&city=${city}`
	)
		.then((response) => response.json())
		.then((data) => ({
			longitude: data.features[0]?.geometry?.coordinates[0],
			latitude: data.features[0]?.geometry?.coordinates[1],
			citycode: data.features[0]?.properties?.citycode,
		}))
		.catch((e) => null)
}

export { fetchCityList, getCoordinates }
